<template>
  <div id="app">
    <top v-if="full"></top>
<!--    <div v-if="queryName !== 'index'" class="main-con">-->
<!--      &lt;!&ndash; 路由占位符 &ndash;&gt;-->
<!--      <router-view />-->
<!--    </div>-->
<!--    <router-view v-else />-->
    <router-view />
    <bottom v-if="full"></bottom>
  </div>
</template>
<script>
  import top from '@/components/top.vue'
  import bottom from '@/components/bottom.vue'
  export default {
    components: {
      top,
      bottom
    },
    name: 'app',
    data() {
      return {
        num: 0,
        themeColor: '',
        themeBgColor: '',
        styleColor: '',
        styleBgColor: '',
        hoverStyle: '',
        hoverStyleBgColor: '',
        navColor: '',
        detailBgcolor: '',
        backgroundImage: '',
        cover: '',
        queryName:'',
        full: false
      }
    },
    watch: {
      '$route': {
        handler(e) {
          this.full = !e.meta.full
          this.queryName = e.name
        },
        immediate: true
      }
    },
    created() {
      // this.$store.state.minHeight = document.documentElement.clientHeight - 286 + 'px'
    },
    updated() {
      this.$nextTick(() => {
        window.scrollTo(0,0)
      })
    },
    methods: {
      // 动态修改网站图标
      changeFavicon(link) {
        let $favicon = document.querySelector('link[rel="icon"]');
        if ($favicon !== null) {
          $favicon.href = link;
        } else {
          $favicon = document.createElement("link");
          $favicon.rel = "icon";
          $favicon.href = link;
          document.head.appendChild($favicon);
        }
      },
    }
  }
</script>
<style lang="less">
  @font-face {
    font-family: 'mountain-font';
    src: url('https://cdn.rockysports.cn/mffont.ttf');
  }
  @font-face {
    font-family: 'Barlow'; //重命名字体名
    src: url('./assets/font/Barlow-BlackItalic.woff2.ttf'); //引入字体
  }

  @font-face {
    font-family: 'PuHui'; //重命名字体名
    src: url('https://cdn.rockysports.cn/PuHuiTi_Black_Black.ttf'); //引入字体
  }

  .font-PuHui{
    font-family: "PuHui","Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }

  .font-Barlow{
    font-family: "Barlow","Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }

  a{
    text-decoration: none;
    color: #fff;
  }

  .flex {
    display: flex;
  }

  .gray-background{
    background-color: #F4F4F6;
  }

  .no-data-img{
    width: 380px;
    height: 200px;
    margin-top: 160px;
  }

  .no-data-explain{
    font-size: 22px;
    color: #666666;
    margin-top: 60px;
    text-align: center;
    margin-bottom: 160px;
  }

  @media screen and (min-width: 1100px) {
    .main-con{
      padding-top: 100px;
    }
    .container {
      width: 100%;
      min-width: 1260px;
      min-height: calc(100vh - 325px);
      position: relative;
      overflow-x: hidden;
      background: var(--backgroundImage);
      background-size: var(--cover);
    }

    .w1280 {
      width: 1280px;
      //position: relative;
      margin: 0 auto;
    }


    .w990 {
      width: 990px;
      //position: relative;
      margin: 0 auto;
    }

    .color-default {
      color: #221815;
    }

    .bg-white {
      background-color: #ffffff;
    }

    .flex-row {
      display: flex;
      flex-direction: row;
    }

    .flex-column {
      display: flex;
      flex-direction: column;
    }

    .align-center {
      align-items: center;
    }

    .align-end {
      align-items: flex-end;
    }

    .justify-center {
      justify-content: center;
    }

    .flex-between {
      justify-content: space-between;
    }

    .page-block {
      // margin-bottom: 60px;
    }

  }

  @media screen and (max-width: 1100px) {
    .main-con{
      padding-top: 100px;
    }

    .color-default {
      color: #221815;
    }

    .bg-white {
      background-color: #ffffff;
    }

    .flex-row {
      display: flex;
      flex-direction: row;
    }

    .flex-column {
      display: flex;
      flex-direction: column;
    }

    .align-center {
      align-items: center;
    }

    .align-end {
      align-items: flex-end;
    }

    .justify-center {
      justify-content: center;
    }

    .flex-between {
      justify-content: space-between;
    }

    .page-block {
      // margin-bottom: 60px;
    }

    .container {
      width: 100%;
      min-height: calc(100vh - 325px);
      position: relative;
      overflow-x: hidden;
      background: var(--backgroundImage);
      background-size: var(--cover);
    }
    .w1280 {
      width: 100%;
      position: relative;
    }

    .w990 {
      width: 100%;
      position: relative;
    }

  }
</style>



// WEBPACK FOOTER //
// src/App.vue